export { default } from './WindStats';
